/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateDietPlanDto } from '../models/CreateDietPlanDto';
import type { UpdateDietPlanDto } from '../models/UpdateDietPlanDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ExpertAppDietPlansService {
    /**
     * Fetch diet plans with tab filtering
     * Returns diet plans for the authenticated expert. Use tab=active for active plans, tab=completed for finished plans, or tab=no_plan to list clients without any diet plan assigned by this expert.
     * @param tab Filter by tab: active, completed, or no_plan (clients without diet plans)
     * @param search Search by client name or plan name
     * @param page Page number (1-indexed)
     * @param pageSize Items per page
     * @returns any Diet plans fetched successfully
     * @throws ApiError
     */
    public static dietPlansControllerFetchDietPlansV1(
        tab?: 'active' | 'completed' | 'no_plan',
        search?: string,
        page: number = 1,
        pageSize: number = 10,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/expert-app/diet-plans',
            query: {
                'tab': tab,
                'search': search,
                'page': page,
                'pageSize': pageSize,
            },
            errors: {
                401: `Unauthorized — invalid or missing JWT`,
                403: `Forbidden — user is not an expert`,
            },
        });
    }
    /**
     * Create a new diet plan for a client
     * Creates a diet plan with weekly meal breakdown, nutritional goals, and additional notes. The client must have at least one booking with the expert.
     * @param requestBody
     * @returns any Diet plan created successfully
     * @throws ApiError
     */
    public static dietPlansControllerCreateDietPlanV1(
        requestBody: CreateDietPlanDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/expert-app/diet-plans',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error or client not assigned to this expert`,
                401: `Unauthorized — invalid or missing JWT`,
                403: `Forbidden — user is not an expert`,
            },
        });
    }
    /**
     * Get diet plan detail
     * Returns the full detail of a diet plan including weekly meal plan, nutritional goals, and additional notes. Only the owning expert can view it.
     * @param id Diet plan UUID
     * @returns any Diet plan fetched successfully
     * @throws ApiError
     */
    public static dietPlansControllerGetDietPlanDetailV1(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/expert-app/diet-plans/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized — invalid or missing JWT`,
                403: `Forbidden — user is not an expert`,
                404: `Diet plan not found or does not belong to this expert`,
            },
        });
    }
    /**
     * Update an existing diet plan
     * Partially updates a diet plan. Only the owning expert can update. JSON fields (nutritional_goals, weekly_meal_plan, additional_notes) are merged with existing values.
     * @param id Diet plan UUID
     * @param requestBody
     * @returns any Diet plan updated successfully
     * @throws ApiError
     */
    public static dietPlansControllerUpdateDietPlanV1(
        id: string,
        requestBody: UpdateDietPlanDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v1/expert-app/diet-plans/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized — invalid or missing JWT`,
                403: `Forbidden — user is not an expert`,
                404: `Diet plan not found or does not belong to this expert`,
            },
        });
    }
    /**
     * Soft-delete a diet plan
     * Sets the diet plan status to "deleted". The plan is excluded from all list views but remains in the database. Only the owning expert can delete it.
     * @param id Diet plan UUID
     * @returns any Diet plan deleted successfully
     * @throws ApiError
     */
    public static dietPlansControllerDeleteDietPlanV1(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/expert-app/diet-plans/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Diet plan is already deleted`,
                401: `Unauthorized — invalid or missing JWT`,
                403: `Forbidden — user is not an expert`,
                404: `Diet plan not found or does not belong to this expert`,
            },
        });
    }
    /**
     * Duplicate an existing diet plan
     * Creates a copy of the specified diet plan with start_date set to today. The duplicated plan is named with a "(Copy)" suffix and has status "active".
     * @param id Diet plan UUID to duplicate
     * @returns any Diet plan duplicated successfully
     * @throws ApiError
     */
    public static dietPlansControllerDuplicateDietPlanV1(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/expert-app/diet-plans/{id}/duplicate',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized — invalid or missing JWT`,
                403: `Forbidden — user is not an expert`,
                404: `Diet plan not found or does not belong to this expert`,
            },
        });
    }
}
